import React, { FC } from "react";
import { Location } from "../../queries/auto-generated/schemas";
import { MapComponent } from "./map-component";
import { MarkerCard } from "./marker-card";

export const MapSingleLocation: FC<{
  location: Location;
  height: string;
  zoom?: number;
}> = ({ location, height, zoom = 11 }) => {
  const { coordinates } = location;
  const lat = coordinates?.latitude;
  const lng = coordinates?.longitude;

  if (lat === undefined || lng === undefined) {
    return null;
  }

  return (
    <div style={{ height, width: "100%" }}>
      <MapComponent center={{ lat, lng }} zoom={zoom}>
        <MarkerCard lat={lat} lng={lng} location={location} />
      </MapComponent>
    </div>
  );
};
